import axios from 'axios';
import { RequestParams } from 'types/pagination';
import { ContainerObject } from 'types/container';

export const getObjects = async (setResults: (value: ContainerObject[]) => void, requestParams: RequestParams) => {
    const params: any = {};
    requestParams?.filters?.forEach((filter) => {
        params[`filter[${filter.name}]`] = filter.value;
    });

    try {
        const response = await axios.get('/search', { params });

        setResults(response.data.results);
    } catch (err) {
        console.error(`Error getting objects ${err}`);
    }
};
export const getAssignmentObjects = async (setResults: (value: ContainerObject[]) => void, requestParams: RequestParams) => {
    const params: any = {};
    requestParams.filters?.forEach((filter) => {
        params[`filter[${filter.name}]`] = filter.value;
    });

    try {
        const response = await axios.get('/search/assignments', { params });

        setResults(response.data.results);
    } catch (err) {
        console.error(`Error getting objects ${err}`);
    }
};

export const getAssignmentFilters = async (restrictToType: number | undefined, product_category_id?: number | undefined) => {
    let filters = [];
    let params;
    if (product_category_id) params = restrictToType !== undefined ? { restrictToType, product_category_id } : { product_category_id };
    else params = restrictToType !== undefined ? { restrictToType, product_category_id } : {};
    try {
        const response = await axios.get(`/search/assignment/filters`, { params });
        filters = response.data.filters;
    } catch (err) {
        console.error(`Error getting assingment filters ${err}`);
    }
    return filters;
};
export const getContainerFilters = async (restrictToType: number | undefined, product_category_id?: number | undefined) => {
    let filters = [];
    let params;
    if (product_category_id) params = restrictToType !== undefined ? { restrictToType, product_category_id } : { product_category_id };
    else params = restrictToType !== undefined ? { restrictToType, product_category_id } : {};
    try {
        const response = await axios.get(`/search/container/filters`, { params });
        filters = response.data.filters;
    } catch (err) {
        console.error(`Error getting container filters ${err}`);
    }
    return filters;
};

export default getObjects;
